import { Link } from '@backstage/core-components';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';

const cardData = [
  {
    title: 'Pluralsight',
    image: '/img/logo/pluralsight_temp.png',
    locationUrl: 'https://www.pluralsight.com/',
    description:
      'Evaluate technical abilities, align learning, and close skills gaps.',
  },
  {
    title: 'LearnQuest',
    image: '/img/logo/learnquest_temp.png',
    locationUrl: 'https://www.learnquest.com/Principal',
    description: 'Classroom, virtual, and self-paced training for IT skills.',
  },
  {
    title: 'LinkedIn Learning',
    image: '/img/logo/linkedin_temp.png',
    locationUrl: 'https://www.linkedin.com/learning/',
    description: 'Learn business, creative and technology skills.',
  },
];

const getTruncatedText = (text: string): string => {
  let result = '';
  if (text?.trim().length > 0) {
    result = text;
    if (result.length > 80) {
      result = result.slice(0, 80);
      result += '...';
    }
  }
  return result;
};

const styles = {
  ribbon: {
    width: '100%',
    padding: '20px 0px',
  },
  card: {
    height: '100%',
  },
  cardLogoImg: {
    height: '50px',
    width: '50px',
    marginBottom: '10px',
  },
  link: {
    fontWeight: 700,
  },
  typography: {
    padding: '0px 0px 20px 0px',
  },
};

export function LearningResources() {
  return (
    <Grid
      container
      spacing={10}
      style={{
        padding: '50px 60px 100px 60px',
      }}
    >
      <div style={styles.ribbon}>
        <Typography gutterBottom variant="h3" align="left">
          Upgrade your skills
        </Typography>
        <Typography style={styles.typography}>
          <Link
            to="https://principalworkplace.sharepoint.com/sites/intranet/bu/IS/Pages/training-description.aspx"
            style={styles.link}
          >
            Review these steps
          </Link>{' '}
          to gain access to these resources.
        </Typography>
        <Grid container spacing={2}>
          {cardData.map((card, index) => {
            return (
              <Grid key={`learning-resources-item-${index}`} item xs>
                <Card style={styles.card}>
                  <CardContent>
                    {card.image && (
                      <img
                        style={styles.cardLogoImg}
                        alt={`${card.title} Logo`}
                        src={card.image}
                      />
                    )}
                    <Typography variant="h6" component="div">
                      <Link to={card.locationUrl}>{card.title}</Link>
                    </Typography>
                    <Typography variant="body2">
                      {getTruncatedText(card.description)}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </Grid>
  );
}
